const SLIDE_DURATION = 6000;

/**
 * Initialize Swiper on a hero banner root element.
 *
 * @param {HTMLElement} heroEl Root `.hero-swiper` element.
 * @return {import('swiper').Swiper|null}
 */
export function initHeroSwiper( heroEl ) {
	if ( ! heroEl || typeof window.Swiper === 'undefined' ) {
		return null;
	}

	if ( heroEl.swiper && ! heroEl.swiper.destroyed ) {
		return heroEl.swiper;
	}

	const progressBar = heroEl.querySelector( '.swiper-progress' );
	const autoplayEnabled = heroEl.getAttribute( 'data-autoplay' ) !== 'false';

	const swiper = new window.Swiper( heroEl, {
		loop: true,
		speed: 900,
		effect: 'fade',
		fadeEffect: { crossFade: true },
		autoplay: autoplayEnabled
			? {
				delay: SLIDE_DURATION,
				disableOnInteraction: false,
			}
			: false,
		pagination: {
			el: heroEl.querySelector( '.swiper-pagination' ),
			clickable: true,
		},
		navigation: {
			nextEl: heroEl.querySelector( '.swiper-button-next' ),
			prevEl: heroEl.querySelector( '.swiper-button-prev' ),
		},
	} );

	const resetProgress = () => {
		if ( ! progressBar ) {
			return;
		}

		if ( ! autoplayEnabled ) {
			progressBar.style.transition = 'none';
			progressBar.style.width = '0%';
			return;
		}

		progressBar.style.transition = 'none';
		progressBar.style.width = '0%';

		requestAnimationFrame( () =>
			requestAnimationFrame( () => {
				progressBar.style.transition = `width ${ SLIDE_DURATION }ms linear`;
				progressBar.style.width = '100%';
			} )
		);
	};

	resetProgress();
	swiper.on( 'slideChange', resetProgress );

	return swiper;
}

/**
 * Initialize every hero swiper on the page.
 */
export function initAllHeroSwipers() {
	document
		.querySelectorAll( '.hero-swiper.swiper' )
		.forEach( ( el ) => initHeroSwiper( el ) );
}
